/*
  La URL del backend no puede quedar compilada dentro del bundle: Create React App
  reemplaza las REACT_APP_* en tiempo de build, asi que una imagen construida para un
  ambiente queda atada a ese ambiente y no se puede promover a otro.

  Este modulo la resuelve en tiempo de ejecucion. El contenedor genera env-config.js
  al arrancar a partir de sus variables de entorno, y ahi se define window.__ENV__.
  El orden de resolucion es: runtime, build, y recien despues el default.
*/

const runtime = () =>
  (typeof window !== "undefined" && window.__ENV__) || {};

export function getConfig(nombre, porDefecto = "") {
  const valor = runtime()[nombre] ?? process.env[`REACT_APP_${nombre}`];
  const limpio = typeof valor === "string" ? valor.trim() : valor;
  return limpio ? limpio : porDefecto;
}

export function getApiProxyBaseUrl() {
  const url = getConfig("API_BASE_URL") || getConfig("API_URL");
  if (!url) {
    throw new Error(
      "No hay URL del API Proxy configurada. Definir API_BASE_URL en env-config.js " +
        "o REACT_APP_API_BASE_URL al construir la imagen.",
    );
  }
  return url.replace(/\/api\/?$/, "").replace(/\/+$/, "");
}
